import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b44213b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  key: 1,
  class: "webins-widget-navigation-mob"
}
const _hoisted_3 = { class: "completion-header" }
const _hoisted_4 = { style: {"float":"left"} }
const _hoisted_5 = {
  class: "text-theme-color",
  style: {"text-align":"right"}
}
const _hoisted_6 = {
  key: 0,
  "data-name": "Livello 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  "svg-inline": '',
  role: 'presentation',
  focusable: 'false',
  tabindex: '-1'
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M100 150.5a6.49 6.49 0 01-4.6-1.9l-70-70a6.51 6.51 0 019.2-9.2l65.4 65.41 65.4-65.41a6.51 6.51 0 019.2 9.2l-70 70a6.49 6.49 0 01-4.6 1.9z",
  "data-name": "Tracciato 18"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  "data-name": "Livello 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  "svg-inline": '',
  role: 'presentation',
  focusable: 'false',
  tabindex: '-1'
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M97.8 58.34a6.47 6.47 0 00-4.59 1.9l-70 70a6.5 6.5 0 009.19 9.19L97.8 74l65.41 65.4a6.5 6.5 0 009.19-9.19l-70-70a6.47 6.47 0 00-4.6-1.87z",
  "data-name": "Tracciato 18"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "completion-percentage-bkg" }

import { computed, defineComponent, ref, watch } from "vue";
import { useI18n } from 'vue-i18n';
import { useNavigation, useWidget, useReservation, usePolizze } from '@/composables';
import MobileSummary from './mobileSummary.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();
const { steps, currentStep, backTo } = useNavigation();
const { forcedPickPoint, isLargeScreen, widgetConfig } = useWidget();
const { reservation } = useReservation();
const { totali } = usePolizze();

const goToStep = (step: number) => {
  backTo(step);
}

const navigationContainerClass = computed(() => {
  let count = uiSteps.value ? uiSteps.value.length : 0;
  return `webins-widget-navigation-${count}`;
});

const uiSteps = computed(() => {
  return steps.value.filter(s => {
    if(widgetConfig.value && widgetConfig.value.abilitaAggiuntaCarrello){
      var stepUsati = [1,3,4];
      return stepUsati.indexOf(s.step) >= 0
    }
      return s.step >= 0;
  });
});

const completionPercentage = computed(() => {
  const numSteps = uiSteps.value.length;
  let stepsDone = currentStep.value;
  if(stepsDone > 0 && forcedPickPoint.value != null) {
    stepsDone = stepsDone - 1;
  }
  const percentage = stepsDone * 100 / numSteps;
  return Math.round(percentage);
});

const mobileMenuOpened = ref(false);
watch(currentStep, () => mobileMenuOpened.value = false);



return (_ctx: any,_cache: any) => {
  return (_unref(isLargeScreen))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["webins-widget-navigation", _unref(navigationContainerClass)])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(uiSteps), (step) => {
          return (_openBlock(), _createElementBlock("div", {
            key: step.step,
            class: _normalizeClass(["webins-widget-navigation-item", { 'completed': step.step < _unref(currentStep), 'selected' : _unref(currentStep)==step.step}]),
            onClick: ($event: any) => (goToStep(step.step)),
            style: {"cursor":"pointer"}
          }, _toDisplayString(step.desc), 11, _hoisted_1))
        }), 128))
      ], 2))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(steps)[_unref(currentStep)].desc), 1),
          _createElementVNode("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(_unref(t)("common.riepilogoDati")) + " ", 1),
            _createElementVNode("span", null, "€ " + _toDisplayString(_unref(totali) && _unref(totali).totaleViaggio ? _unref(totali).totaleViaggio : '0'), 1),
            _createElementVNode("a", {
              class: "mob-toggle-btn",
              style: {"cursor":"pointer"},
              onClick: _cache[0] || (_cache[0] = ($event: any) => (mobileMenuOpened.value = !mobileMenuOpened.value))
            }, [
              (!mobileMenuOpened.value)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_8))
                : (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_11))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", {
            class: "completion-percentage",
            style: _normalizeStyle('width:' + _unref(completionPercentage) + '%')
          }, null, 4)
        ]),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (mobileMenuOpened.value)
              ? (_openBlock(), _createBlock(MobileSummary, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
}
}

})